import { jsx as _jsx } from "react/jsx-runtime";
import { ShowBase } from "react-admin";
import { ElectionTabs } from "../Election/ElectionTabs";
export var ElectionBaseTabs = function () {
    return (_jsx(ShowBase, { children: _jsx(ElectionTabs, {}) }));
};
